import { memo } from "react"
import { Stack, Typography } from "@mui/material"

import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { AbandonBookingDialog } from "../../AbandonBookingDialog"
import type { NullableCalendarEvent } from "../calendar/fullCalendarTypes"

import type { TimeChangeDialogState } from "./useTimeChangeDialog"

type TimeChangeDialogProps = Readonly<{
    state: TimeChangeDialogState
    localEvent: NullableCalendarEvent
    onKeepOriginalTime: () => void
    onConfirmTimeChange: () => void
}>

export const TimeChangeDialog = memo(function TimeChangeDialog({
    state,
    localEvent,
    onKeepOriginalTime,
    onConfirmTimeChange,
}: TimeChangeDialogProps) {
    const dateTimeFactory = useDateTime()

    return (
        <LocalizedStrict
            id="create-order-change-time-dialog"
            attrs={{ title: true, buttonLabelSubmit: true, buttonLabelCancel: true }}
        >
            <AbandonBookingDialog
                title="Change booking time?"
                message={
                    <Stack gap="1rem">
                        <Typography variant="body1">
                            <LocalizedStrict id="create-order-change-time-dialog-message-top">
                                <>Your Outlook meeting request is scheduled for:</>
                            </LocalizedStrict>
                            <Typography fontWeight={500}>
                                {localEvent
                                    ? dateTimeFactory.formatCompactPeriodFromDateTime(
                                          dateTimeFactory.fromISO(localEvent.start),
                                          dateTimeFactory.fromISO(localEvent.end),
                                      )
                                    : ""}
                            </Typography>
                        </Typography>
                        <Typography variant="body1">
                            <LocalizedStrict id="create-order-change-time-dialog-message-bottom">
                                <>Do you want to change booking time to:</>
                            </LocalizedStrict>
                            <Typography fontWeight={500}>
                                {dateTimeFactory.formatCompactPeriodFromDateTime(
                                    dateTimeFactory.fromISO(state.newStart),
                                    dateTimeFactory.fromISO(state.newEnd),
                                )}
                            </Typography>
                        </Typography>
                    </Stack>
                }
                handleSubmitClick={onConfirmTimeChange}
                handleCancelClick={onKeepOriginalTime}
                buttonLabelSubmit="Use new time"
                buttonLabelCancel="Keep original time"
                open
                onClose={onKeepOriginalTime}
            />
        </LocalizedStrict>
    )
})

